import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const ImagesReducer = CreateGenericReducer(constructs.image);
